import { optionSchema } from "@/common/schemas/option.schema";
import z from "zod";

export const directiveComplexitySchema = z.object({
  complexity: optionSchema,
});

export const directiveDiagnosticSchema = z.object({
  diagnostic: optionSchema,
});

// export const establishmentChoiceEntrySchema = z.object({
//   establishment_choice_entry_type: z.string(),
//   establishment_choice_entry_attributes: z.object({
//     establishment_id: z.string().optional(),

//     minimum_of_proposals_to_finish: z.string().optional(),
//     allowance_radius_in_kilometers: z.string().optional(),
//     finish_at_date: z.string().optional(),
//     finish_at_time: z.string().optional(),

//     wip_kind: optionSchema.optional(),
//     wip_schedule: z.boolean().optional(),
//     wip_init_date: z.string().optional(),
//     wip_init_time: z.string().optional(),
//     wip_establishments: z.string().optional(),
//     wip_establishments_ids: z.array(z.string()).optional(),
//   }),
// });

// export type EstablishmentChoiceEntryValidationSchema = z.infer<typeof establishmentChoiceEntrySchema>;

export const checkinEntrySchema = z.object({
  checkin_entry_type: z.string(),
  checkin_entry_attributes: z.object({
    responsible: optionSchema,
  }),
});

export type DirectiveComplexityValidationSchema = z.infer<typeof directiveComplexitySchema>;

export type DirectiveDiagnosticValidationSchema = z.infer<typeof directiveDiagnosticSchema>;


export type CheckinEntryValidationSchema = z.infer<typeof checkinEntrySchema>;
